import { TFunction } from 'i18next';
import { FaClock } from 'react-icons/fa';
import { CUSTOM_COLOURS, CUSTOM_TQ_COLOURS } from '../../../../styles';
import { STANDARD_WIDTH } from '../useConsultationStatuses';
import { UseConsultationStatusReturn } from './useConsultationStatusReturn';

export const tqConsultationStatusesConfig = (t: TFunction): UseConsultationStatusReturn => {
  return {
    New: {
      label: t('new', 'New'),
      badgeProps: {
        color: 'green.500',
        bgColor: 'white',
        width: STANDARD_WIDTH,
        border: 'solid 2px',
      },
    },
    Active: {
      label: t('active', 'Active'),
      badgeProps: {
        color: 'white',
        bgColor: 'blue.275',
        width: STANDARD_WIDTH,
      },
    },
    'Active isNearingDeadline': {
      label: t('active', 'Active'),
      badgeProps: { bgColor: 'orange.550', width: STANDARD_WIDTH },
      icon: FaClock,
    },
    Update: {
      label: t('updated', 'Update'),
      badgeProps: {
        bgColor: 'purple.600',
        width: STANDARD_WIDTH,
      },
    },
    Resubmission: {
      label: t('resubmission', 'Resubmission'),
      badgeProps: {
        bgColor: 'blue.300',
      },
    },
    'Extension requested': {
      label: t('extension_requested', 'Extension requested'),
      badgeProps: {
        color: 'black',
        bgColor: 'grey.450',
      },
    },
    'Extension refused': {
      label: t('extension_refused', 'Extension refused'),
      badgeProps: {
        bgColor: 'red.850',
      },
    },
    'Extension granted': {
      label: t('extended_granted', 'Extension granted'),
      badgeProps: {
        bgColor: CUSTOM_COLOURS.darkGreen,
      },
    },
    Overdue: {
      label: t('overdue', 'Overdue'),
      badgeProps: {
        bgColor: 'red.850',
        width: STANDARD_WIDTH,
      },
    },
    'Response rejected': {
      label: t('response_rejected', 'Response rejected'),
      badgeProps: {
        bgColor: 'red.400',
      },
    },
    Responded: {
      label: t('responded', 'Responded'),
      badgeProps: {
        color: 'black',
        bgColor: 'green.900',
        width: STANDARD_WIDTH,
      },
    },
    Closed: {
      label: t('closed', 'Closed'),
      badgeProps: { bgColor: 'grey.950', width: STANDARD_WIDTH },
    },
    Withdrawn: {
      label: t('withdrawn', 'Withdrawn'),
      badgeProps: {
        bgColor: CUSTOM_TQ_COLOURS.grey777E86,
      },
    },
    'Consulted in error': {
      label: t('consulted_in_error', 'Consulted in error'),
      badgeProps: {
        bgColor: 'red.400',
      },
    },
    Determined: {
      label: t('determined', 'Determined'),
      badgeProps: {
        bgColor: 'grey.950',
        width: STANDARD_WIDTH,
      },
    },
  };
};
